import { useMutation, useQuery } from "@apollo/client/react";
import { GQLQuery, GQLMutation } from "@rx-cs-system/schema";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router";

import { useCheckUserRole, useHandleError } from "../../../hooks";
import { GET_PRESCRIPTION_BY_PRESCRIPTION_CODE } from "../../../graphql/queries";
import { parsePrescriptionCancel } from "../../../graphql/utils";
import {
  PrescriptionCancelPage as Component,
  PrescriptionCancelProps,
} from "../../../components/pages/prescription/PrescriptionCancelPage";
import { FORCE_CANCEL_PRESCRIPTION } from "../../../graphql/mutations";
import { useSnackBar } from "../../../hooks/useSnackBar";

export const PrescriptionCancelPage = ({}) => {
  useCheckUserRole();

  const navigate = useNavigate();
  const { snackBar, showOKSnackBar } = useSnackBar();
  const [isCancelPrescription, setIsCancelPrescription] = useState(false);
  const [prescriptionCode, setPrescriptionCode] = useState("");

  const { error, data, loading, refetch } = useQuery<GQLQuery>(
    GET_PRESCRIPTION_BY_PRESCRIPTION_CODE,
    {
      variables: { prescriptionCode },
    },
  );
  const [forceCancelPrescription] = useMutation<GQLMutation>(
    FORCE_CANCEL_PRESCRIPTION,
    {
      onCompleted: (result) => {
        if (
          result.forceCancelPrescription?.__typename ===
          "ForceCancelPrescriptionError"
        ) {
          navigate(`/cancelPrescription/error`, {
            state: {
              message: `ForceCancelPrescriptionError: ${result.forceCancelPrescription.message}`,
              prescriptionCode,
            },
          });
        } else {
          refetch();
          showOKSnackBar("処方をキャンセルしました。");
          setIsCancelPrescription(false);
        }
      },
      onError: (e) => {
        navigate(`/cancelPrescription/error`, {
          state: {
            message: `onError: ${e.message}`,
            prescriptionCode,
          },
        });
      },
    },
  );
  useHandleError(error);

  const prescription = useMemo(() => {
    if (!data?.prescriptionByPrescriptionCode) {
      return prescriptionCode === "" ? undefined : null;
    }
    return parsePrescriptionCancel(data.prescriptionByPrescriptionCode);
  }, [data, prescriptionCode]);

  const handleSearchClick = (keyword: string) => {
    setPrescriptionCode(keyword);
  };

  const handleSubmitClick = async () => {
    if (prescription?.codeStatus === "CANCELED") {
      return alert("キャンセル済処方のためキャンセルできません");
    }
    const isOk = confirm(
      "本当に処方をキャンセルしますか？キャンセルしたら元には戻せません。",
    );
    if (isOk) {
      setIsCancelPrescription(true);
      await forceCancelPrescription({
        variables: {
          input: {
            prescriptionCode,
          },
        },
      });
    }
  };

  const props: PrescriptionCancelProps = {
    isCancelPrescription,
    isLoading: loading,
    prescription,
    snackBar,
    onSearchClick: handleSearchClick,
    onSubmitClick: handleSubmitClick,
  };

  return <Component {...props} />;
};
